const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const WS_URL = "wss://api.gateio.ws/ws/v4/";

const toSec = (x) => (x > 2e10 ? Math.floor(x / 1000) : Number(x));
const toLwc = (t, o, h, l, c) => ({
  time: t,
  open: Number.isFinite(+o) ? +o : undefined,
  high: Number.isFinite(+h) ? +h : undefined,
  low:  Number.isFinite(+l) ? +l : undefined,
  close:Number.isFinite(+c) ? +c : undefined,
});

export async function gateSpotFetchHistory({ symbol, interval, limit = 300 }) {
  const url = `${PROXY}/https://api.gateio.ws/api/v4/spot/candlesticks?currency_pair=${encodeURIComponent(symbol)}&interval=${encodeURIComponent(interval)}&limit=${limit}`;
  console.log("[gateSpot REST] fetch", { symbol, interval, limit, url });
  // const r = await fetch(url);
  const r = await fetch(url, {
    headers: {
      'ngrok-skip-browser-warning': 'true',
    },
  });
  if (!r.ok) throw new Error(`Gate SPOT HTTP ${r.status}`);
  const rows = await r.json();
  const out = rows
    // resp: [ ts, quoteVol, close, high, low, open, baseVol, closed? ]
    .map(a => toLwc(toSec(+a[0]), +a[5], +a[3], +a[4], +a[2]))
    .sort((x, y) => x.time - y.time)
    .slice(-limit);
  console.log("[gateSpot REST] done", { symbol, interval, count: out.length });
  return out;
}

export function gateSpotOpenWS({ symbol, interval, onCandle }) {
  console.log("[gateSpot WS] open", { symbol, interval });
  const ws = new WebSocket(WS_URL);
  let opened = false;

  const close = () => {
    try {
      if (opened && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
          time: Date.now(),
          channel: "spot.candlesticks",
          event: "unsubscribe",
          payload: [interval, symbol],
        }));
        console.log("[gateSpot WS] unsubscribe", { symbol, interval });
      }
    } catch (e) { console.warn("[gateSpot WS] unsubscribe error", e); }
    try { ws.close(); } catch {}
    console.log("[gateSpot WS] closed");
  };

  ws.onopen = () => {
    opened = true;
    ws.send(JSON.stringify({
      time: Date.now(),
      channel: "spot.candlesticks",
      event: "subscribe",
      payload: [interval, symbol],
    }));
    console.log("[gateSpot WS] subscribed", { symbol, interval });
  };

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data);
      if (msg.channel !== "spot.candlesticks" || msg.event !== "update") return;
      const r = msg.result;
      if (!r) return;
      const t = toSec(+r.t);
      const c = toLwc(t, +r.o, +r.h, +r.l, +r.c);
      onCandle?.(c);
    } catch {}
  };

  ws.onerror = (e) => console.warn("[gateSpot WS] error", e);
  ws.onclose = () => console.log("[gateSpot WS] onclose");

  return close;
}
